<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Set Mailchimp Audience</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h3 *ngIf="loadingAudiences" class="text-secondary">Loading audiences...</h3>

    <ng-container *ngIf="!loadingAudiences">
      <label>Select which Mailchimp audience will receive data from Capitan:</label>

      <p *ngIf="audiences.length === 0">No Mailchimp audiences found</p>

      <div class="form-check" *ngFor="let audience of audiences">
        <input class="form-check-input" type="radio" name="selectedAudience"
               id="selectedAudience{{ audience.id }}"
               [value]="audience" [(ngModel)]="selectedAudience">
        <label class="form-check-label" for="selectedAudience{{ audience.id }}">
          {{ audience.name }}
        </label>
      </div>

      <label class="mt-3">Select how to sync data with Mailchimp:</label>

      <div class="form-check">
        <input class="form-check-input" type="radio" name="syncFromMailchimp" id="syncFromMailchimpTrue"
               [value]="true" [(ngModel)]="syncFromMailchimp">
        <label class="form-check-label" for="syncFromMailchimpTrue">
          <b>Keep customers' Mailchimp email opt-in preferences, and override their opt-in settings in Capitan.</b>
          <br>
          When a customer is present both in Capitan and in Mailchimp, their Mailchimp opt-in settings will override any preferences currently set in Capitan.
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="syncFromMailchimp" id="syncFromMailchimpFalse"
               [value]="false" [(ngModel)]="syncFromMailchimp">
        <label class="form-check-label" for="syncFromMailchimpFalse">
          <b>Keep customers' Capitan email opt-in preferences, and override their opt-in settings in Mailchimp.</b>
          <br>
          When a customer is present both in Capitan and in Mailchimp, their Capitan opt-in settings will override any preferences currently set in Mailchimp.
        </label>
      </div>

      <div class="form-check mt-3">
        <input class="form-check-input" type="checkbox" name="hasConfirmed" id="hasConfirmed"
               [(ngModel)]="hasConfirmed">
        <label class="form-check-label text-danger" for="hasConfirmed">
          <b>I understand this action cannot be undone.</b>
        </label>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            [disabled]="!canSave()"
            [class.disabled]="!canSave()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
